import { PageLoader } from '@/components'
import { AuthenticatedOutlet } from '@/providers'
import { useCurrentPatient } from '@/services'
import { Navigate } from 'react-router-dom'

export const CareToolsEnabledGuard = () => {
  const { data, isLoading } = useCurrentPatient()

  if (isLoading) return <PageLoader />

  // Diashow/Medien sind relevant, wenn die Station Pflegetools ODER die
  // Patienten-UI nutzt (dort laeuft die Diashow auf dem Patienten-Tablet).
  // Nur redirecten, wenn beides explizit deaktiviert ist.
  if (data && data.care_tools_enabled === false && !data.patient_ui_enabled)
    return <Navigate to="../dashboard" replace />

  // AuthenticatedOutlet (statt Outlet), damit der über useOutletContext
  // weitergereichte Auth-Kontext nicht abreißt – sonst crasht die Kindseite.
  return <AuthenticatedOutlet />
}
